import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { SocialNetworksService } from 'dmmp-services'
import { ContentWebsiteShareSocialNetworks, ModuleShareSocialNetworks, SocialNetworkTooltip } from '../../interfaces'
import { PlatformLocation } from '@angular/common'
import { animate, query, stagger, style, transition, trigger } from '@angular/animations'




@Component({
  selector: 'dmmp-website-share-social-networks',
  templateUrl: './website-share-social-networks.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition('* <=> *', [
        query(':enter', [
          style({opacity: 0}),
          stagger(100, [animate('0.2s ease-in-out', style({opacity: 1}))])
        ], {optional: true}),
        query(':leave', [
          style({opacity: 1}),
          stagger(-100, [animate('0.2s ease-in-out', style({opacity: 0}))])
        ], {optional: true})
      ])
    ])
  ]
})
export class WebsiteShareSocialNetworksComponent implements OnInit {
  @Input() module: ModuleShareSocialNetworks<ContentWebsiteShareSocialNetworks[], SocialNetworkTooltip[]>
  @Input() identifier: string
  tooltipOpened = false
  currentUrl = this.platformLocation.href
  socialNetworkQuantity: number

  constructor(
    private socialNetworksService: SocialNetworksService,
    private platformLocation: PlatformLocation
  ) {}

  ngOnInit(): void {
    this.socialNetworkQuantity = Number(this.module.social_network_quantity)
  }

  openSocialNetwork(social: ContentWebsiteShareSocialNetworks) {
    switch (social.name) {
      case 'facebook':
        this.socialNetworksService.facebookService.initApp()
        this.socialNetworksService.facebookService.shareFacebook(
          this.currentUrl
        )
        break
      case 'whatsapp':
        this.socialNetworksService.whatsAppService.openWhatsAppApp(
          this.currentUrl
        )
        break
      case 'linkedin':
        this.socialNetworksService.linkedInService.shareLinkedin(
          this.currentUrl
        )
        break
      case 'messenger':
        this.socialNetworksService.messengerService.shareMessengerMobile(
          this.currentUrl
        )
        break
      case 'twitter':
        this.socialNetworksService.twitterService.openTwitter(this.currentUrl)
        break
      case 'skype':
        this.socialNetworksService.skypeService.shareURL(this.currentUrl)
        break
    }
  }

  toggleTooltip() {
    this.tooltipOpened = !this.tooltipOpened
  }
}
